import './QuickAccess.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { Menu } from 'antd';
import { QuickAccessApps } from './QuickAccessApps';
import { QuickAccessComplianceCategories } from './QuickAccessComplianceCategories';
import { QuickAccessTags } from './QuickAccessTags';
import { QuickAccessViews } from './QuickAccessViews';
import React from 'react';
import { SearchTypeLabel } from './SearchTypeLabel';
import { SonarCard } from '@ui/general';
import { SonarText } from '@ui/text';
import { SearchOptionGroup, sonarObjectTypeOrder } from './DataDictionarySearch';
const entityItems = [{
        children: Object.values(sonarObjectTypeOrder).map((type) => ({
            group: SearchOptionGroup.ObjectType,
            key: type,
            label: React.createElement(SearchTypeLabel, { sonarObjectType: type }),
            value: type
        })),
        key: 'title',
        label: COPY_SPECIFIC.ENTITIES,
        type: 'group'
    }];
export const QuickAccess = ({ updateQuery }) => React.createElement(SonarCard, { className: 'quick-access', title: React.createElement(SonarText, { size: 20, weight: 'semibold' }, COPY_SPECIFIC.QUICK_ACCESS) },
    React.createElement("div", { className: 'quick-access-menus' },
        React.createElement(Menu, { className: 'quick-access-menu', items: entityItems, mode: 'inline', onClick: (info) => {
                updateQuery({ sonarObjectType: info.key });
            } }),
        React.createElement(QuickAccessViews, { onSelect: updateQuery }),
        React.createElement(QuickAccessTags, { onSelect: (tagId) => updateQuery({ tagId }) }),
        React.createElement(FeatureBoundary, { feature: FeatureFlag.DataSecurityDashboard },
            React.createElement(QuickAccessApps, { onSelect: (applicationId, displayName) => updateQuery({
                    applicationId,
                    displayName
                }) })),
        React.createElement(QuickAccessComplianceCategories, { onSelect: updateQuery })));
